import React, {useState} from 'react';
import {withRouter} from 'react-router-dom';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import {AVAILABLELANGUAGES} from '../../../constants'

import classNames from 'classnames'
import styles from './LanguageSwither.module.scss'

import i18n from '../../../i18n';
import {useTranslation} from "react-i18next";
import IconShevronDownSVG from "../../svg/icon-shevron-down"
import useDataLayer from "../../hook/useDatalayer";
// import {useDispatch} from "react-redux";
// import * as actions from "../../../store/actions";


const LanguageSwitcher = (props) => {
    // const dispatch = useDispatch();
    const {parent, isMobile, onClose} = props;

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [mobileLangOpen, setMobileLangOpen] = useState(false);

    const {t} = useTranslation();

    const { sendDataToDataLayer } = useDataLayer();

    const toggle = () => setDropdownOpen(prevState => !prevState);

    const changeLanguage = (lng) => {

        let currLng = i18n.language;

        let path = props.history.location.pathname.split('/');
        let ind = path.indexOf(currLng);

        if (lng !== 'en') {

            if (ind > -1) {
                path[ind] = lng;
            } else {
                path.splice(1, 0, lng);
            }

        } else {

            if (ind > -1) {
                path.splice(ind, 1);
            }
        }

        props.history.push(path.join('/'));

        sendDataToDataLayer({
            event: "AngelDashboardEvent",
            eventCategory: "Angel dashboard",
            eventAction: "click change language",
            eventLabel: lng,
        })

        i18n.changeLanguage(lng);
    }

    if (isMobile) {
        return <div>
            <span
                onClick={() => setMobileLangOpen(prevState => !prevState)}
                className={styles.mobileDropdownItem}
            >
                {t(`currentFull`)}<IconShevronDownSVG/>
            </span>
            {mobileLangOpen && <div className={styles.mobileList}>
                {
                    AVAILABLELANGUAGES.map(item => {
                        if (item.id !== i18n.language)

                        return (
                            <span
                                className={styles.mobileDropdownItem}
                                key={item.id}
                                onClick={() => {
                                    onClose();
                                    changeLanguage(item.id)}
                                }>
                            {t(item.name)}
                        </span>
                        )
                    })
                }
            </div>}
        </div>
    } else {
        return (
            <Dropdown tag={'div'}
                      className={classNames([styles.dropdown, styles[props.className]])}
                      isOpen={dropdownOpen}
                      toggle={toggle}>

                <DropdownToggle tag={'div'}
                                className={classNames([styles.dropdownTogler, dropdownOpen ? styles.open : null])}>
                    {
                        parent === "header" ? t(`currentShort`) : t(`currentFull`)
                    }
                    <IconShevronDownSVG/>
                </DropdownToggle>
                <DropdownMenu>
                    {
                        AVAILABLELANGUAGES.map(item => (
                            <DropdownItem
                                className={styles.standartDropdownItem}
                                key={item.id}
                                tag={'div'}
                                onClick={() => changeLanguage(item.id)}>
                                {
                                    parent === "header" ? t(item.name) : t(item.name)
                                }

                            </DropdownItem>
                        ))
                    }
                </DropdownMenu>
            </Dropdown>
        )
    }


}

LanguageSwitcher.defaultProps = {
    parent: 'header'
}

export default withRouter(LanguageSwitcher);